import { Edge, Connection } from 'reactflow';

/**
 * Checks if adding a connection would create a cycle in the graph.
 * Returns true if a cycle is detected.
 */
export const isCyclic = (edges: Edge[], connection: Connection): boolean => {
  const target = connection.target;
  const source = connection.source;

  if (!target || !source || target === source) return true;

  // Build adjacency list from existing edges
  const adj = new Map<string, string[]>();
  edges.forEach(edge => {
    if (!adj.has(edge.source)) adj.set(edge.source, []);
    adj.get(edge.source)?.push(edge.target);
  });

  // We are checking if adding source->target creates a cycle.
  // This implies we need to check if there is already a path from target -> source.
  // If such a path exists, connecting source -> target closes the loop.
  
  const visited = new Set<string>();
  const stack = [target];

  while (stack.length > 0) {
    const curr = stack.pop()!;
    if (curr === source) return true; // Found a path back to source

    if (!visited.has(curr)) {
      visited.add(curr);
      const neighbors = adj.get(curr) || [];
      for (const neighbor of neighbors) {
        if (!visited.has(neighbor)) {
          stack.push(neighbor);
        }
      }
    }
  }

  return false;
};